import { Model as t } from "../../../../model.js";
class o extends t {
  constructor(s) {
    super(), this.settings = s.settings, this.design = s.design;
  }
}
export {
  o as TierConfigurationModel
};
//# sourceMappingURL=tierConfiguration.model.js.map
